<div class="wrapper wrap">
  <div
    class="container"
    *ngIf="childrenDepartments && childrenDepartments.length > 0"
  >
    <div class="department-block mt-4">
      <div class="wrapper" role="main">
        <div class="row">
          <div class="col-12">
            <h1 style="margin: 0;">{{datastoreService?.pageContent?.calendar_page_subtitle}}</h1>
            <p class="body-xl">Choose a date and time</p>
            @if (agentMode) { 
              <button type="button" class="govuk-button govuk-button--inverse heading-button" data-module="govuk-button"
                (click)="datastoreService?.agentRestart()">
                Agent Restart
              </button>
            }
            <hr>
          </div>
        </div>
        <div class="department-div">
          <div
            class="department"
            *ngFor="let department of childrenDepartments"
            (click)="selectDepartment(department)"
            tabindex="0"
            [attr.aria-label]="'Department' + department.name"
            role="button"
          >
            {{ department.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
